import {
  getConversation,
  onConversationChange,
} from '@liveHelper/models/persistence/conversation'
import {
  addLiveHelper,
  liveHelperActions,
} from '@oneToOne/shared/utils/liveHelperActions'

import { getPageUrl } from '@core/window'

function lazyLoad() {
  const conversation = getConversation()
  if (conversation) {
    addLiveHelper()
  } else {
    const unsubscribe = onConversationChange((conversationId) => {
      if (conversationId) {
        addLiveHelper()
        unsubscribe()
      }
    })
  }
}

/** Attaches live helper fwn module. */
export function attach() {
  if (
    typeof window !== 'undefined' &&
    !Object.prototype.hasOwnProperty.call(window._fwn, 'liveHelper')
  ) {
    try {
      const urlString = getPageUrl()
      const url = urlString ? new URL(urlString) : null

      switch (url?.searchParams.get('fw_oto_action')) {
        case 'show':
          liveHelperActions.showWidget({
            bypass_widget_availability_hidden: true,
          })
          break
        case 'call':
          liveHelperActions.startCall({
            bypass_widget_availability_hidden: true,
          })
          break
        case 'chat':
          liveHelperActions.startChat({
            bypass_widget_availability_hidden: true,
          })
          break
        default:
          break
      }
    } catch {
      // ignore errors silently, for example invalid url when inside iframe
    }

    Object.defineProperty(window._fwn, 'liveHelper', {
      value: {
        actions: liveHelperActions,
      },
      writable: false,
    })
    if (/complete|interactive|loaded/.test(document.readyState)) {
      // In case the document has finished parsing, document's readyState will
      // be one of "complete", "interactive" or (non-standard) "loaded".
      lazyLoad()
    } else {
      // The document is not ready yet, so wait for the DOMContentLoaded event
      document.addEventListener('DOMContentLoaded', lazyLoad, false)
    }
  }
}
